import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import ChooseCardThemeCategoryPage from './ChooseCardThemeCategoryPage';

const ChooseCardThemeCategoryRoute: FuseRouteItemType = {
  path: '',
  element: <ChooseCardThemeCategoryPage />,
  auth: AUTH_ROLES.parent,
};

export default ChooseCardThemeCategoryRoute;
